{
  "changeLogTitle": "Registro de cambios",
  "help": {
    "tooltip": "¿Qué se rastrea",
    "title": "Qué se registra en el registro de cambios",
    "layersCreatedDeleted": "Creaciones y eliminaciones de capas.",
    "mapObjectsGrouped": "Creaciones, eliminaciones y ediciones geométricas de objetos de mapas agrupadas por usuario y hora.",
    "mapObjectEditHint": "Las ediciones únicas de objetos del mapa cuentan como una edición si se realizan con una diferencia de 5 minutos entre sí.",
    "layerOperationsGrouped": "Operaciones de copia, importación y desvinculación de capas."
  },
  "dateTimes": {
    "today": "Hoy",
    "yesterday": "Ayer",
    "todayAt": "Hoy a las {{ time }}",
    "yesterdayAt": "Ayer a las {{ time }}",
    "dayAt": "{{ day }} a las {{ time }}",
    "aWeekAgo": "Hace una semana",
    "weekday0": "domingo",
    "weekday1": "lunes",
    "weekday2": "martes",
    "weekday3": "miércoles",
    "weekday4": "jueves",
    "weekday5": "viernes",
    "weekday6": "sábado"
  },
  "labels": {
    "layerFallbackName": "Capa",
    "multipleLayers": "Múltiples capas",
    "viewDetails": "Ver detalles"
  },
  "subTitles": {
    "layerImported": "Capa importada",
    "layersImported": "Capas importadas",
    "layerUnlinked": "Capa desvinculada",
    "layersUnlinked": "Capas desvinculadas",
    "layerCopied": "Capa copiada",
    "layersCopied": "Capas copiadas",
    "layerCreated": "Capa creada",
    "layerDeleted": "Capa eliminada",
    "layerEdited": "Capa editada"
  },
  "details": {
    "layerImported": "Capa importada: {{ layerName }}",
    "layerUnlinked": "Capa desvinculada: {{ layerName }}",
    "layerCreated": "Capa creada: {{ layerName }}",
    "mapObjectCreated": "{{ count }} Objeto de mapa creado",
    "mapObjectsCreated": "{{ count }} Objetos de mapa creados",
    "mapObjectUpdated": "{{ count }} Objeto de mapa editado",
    "mapObjectsUpdated": "{{ count }} Objetos de mapa editados",
    "mapObjectDeleted": "{{ count }} Objeto de mapa eliminado",
    "mapObjectsDeleted": "{{ count }} Objetos de mapa eliminados"
  }
}